module.exports = __webpack_public_path__ + "static/media/PlanIt.543cc92b.png";